import { isoZ, z } from 'my-zod'
import { customerWaiverSystemView } from './customer-waivers-system-view'
import { operatorsModel } from '../../outfitter-account-management/outfitter'

export const WaiverOriginationEnum = z.enum(['CustomerWebWaiver', 'OperatorAppWaiver'])

export const customerWaiverAdminView = customerWaiverSystemView
  .pick({
    id: true,
    operatorId: true,
    createdDate: true,
    lastModifiedDate: true
  })
  .augment({
    driverFirstName: customerWaiverSystemView.shape.firstName,
    driverLastName: customerWaiverSystemView.shape.lastName,
    driverDOB: isoZ.date().nullable(),
    driverEmail: customerWaiverSystemView.shape.email,
    driverPrimaryPhone: customerWaiverSystemView.shape.primaryPhone,

    driverPostalCode: z.string().nullable(),
    driverAddressLine1: z.string().nullable(),
    driverAddressLine2: z.string().nullable(),
    driverAddressCity: z.string().nullable(),
    driverAddressState: z.string().nullable(),
    driverAddressCountry: z.string().nullable(),

    driverLicenseNumber: z.string().nullable(),
    driverLicenseState: z.string().nullable(),

    customerId: z.string().uuid().nullable(),
    customerOrderId: z.string().uuid().nullable(),

    productLineForRental: z.string().nullable(),
    operatorCustomProductForRental: z.string().nullable(),
    proposedRideDate: isoZ.date().nullable(),
    vehicleModel: z.string().nullable(),
    rentalLengthHours: z.number().nullable(),

    waiverFormSnapshotUrl: z.string().nullable(),
    waiverOrigination: WaiverOriginationEnum.nullable(),

    // legacy riders/participant interface
    additionalParticipantFullName1: z.string().nullish(),
    additionalParticipantFullName2: z.string().nullish(),
    additionalParticipantFullName3: z.string().nullish(),
    additionalParticipantFullName4: z.string().nullish(),
    additionalParticipantFullName5: z.string().nullish(),

    isParticipant1Minor: z.boolean().nullish(),
    isParticipant2Minor: z.boolean().nullish(),
    isParticipant3Minor: z.boolean().nullish(),
    isParticipant4Minor: z.boolean().nullish(),
    isParticipant5Minor: z.boolean().nullish(),

    operatorName: operatorsModel.shape.businessName.nullish()
  })
